import type { AlertDto, AlertValues, Currency } from "@nabla/api";
import { amount } from "../../design/format/money.ts";
import { eventRoundsCopy as t } from "./copy.ts";

interface On {
  readonly alert: AlertDto;
  readonly currency: Currency | undefined;
}

export const alerts = {
  "gasto-na-hora": {
    says: (v: AlertValues<"gasto-na-hora">, on: On) => {
      const { currency } = on;
      const cash = (minor: AlertValues<"gasto-na-hora">["gasto"]) => (currency === undefined ? "—" : amount({ minor, currency }));
      return t.gasto(on.alert.object?.name ?? v.campanha, cash(v.gasto), String(v.hora).padStart(2, "0"), cash(v.limite));
    },
    next: t.proximo,
  },
  "produto-esgotado": { says: (v: AlertValues<"produto-esgotado">) => t.esgotado(v.produto, v.anuncios), next: t.proximo },
};
